export const SEPARATOR_SELECTOR_CLASSNAME = 'summer-separator-title'
export const HEADER_ELEMENT_ID = 'header'

export const INITIAL_PROGRESS = {
    completedItems: 0,
    lineProgress: 0,
}

export const PROGRESS_ITEMS = [
    {
        title: 'آفتاب دوست‌داشتنی',
        color: '#FFDC66',
    },
    {
        title: 'نرم و مرطوب',
        color: '#19C2C7',
    },
    {
        title: 'شاد و رنگی',
        color: '#923BB3',
    },
    {
        title: 'همراه کاربردی',
        color: '#B06EA3',
    },
    {
        title: 'رایحه ماندنی',
        color: '#A34714',
    },
]
